import { Routes } from '@angular/router';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { tenantInterceptor } from './modules/base/interceptor/tenant.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { OrderPortalGlobalState } from './shared/state/order-portal-global.state';
import { authGuard } from './modules/base/guards/auth.guard';
import { permissionGuard } from './modules/base/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'accounts',
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((acc) => acc.AUTH_ROUTES),
    providers:[importProvidersFrom([NgxsModule.forFeature([OrderPortalGlobalState])])]
  },

  {
    path: '',
    loadComponent: () =>
      import('./shared/layouts/default-layout/default-layout.component').then(
        (l) => l.DefaultLayoutComponent
      ),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.routes').then(
            (d) => d.DASHBOARD_ROUTES
          ),
        data: { title: 'Dashboard' },
        canActivate:[authGuard]
      }
    ],
    providers:[ importProvidersFrom([NgxsModule.forFeature([OrderPortalGlobalState])])],
    canActivate:[authGuard]

  },
];
